// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Sl-z","tupacHeader":"Tl-z","tupacHeader2":"Ul-z","tupacMenu":"Vl-z","tupacMenu2":"Wl-z","tupacMain":"Xl-z","tupacMain2":"Yl-z"};